import styled from 'styled-components';
import { transparentize } from 'utils/color';

export const ItemActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type AccessibilityContainerProps = {
  theme: any;
  visible: boolean;
};

export const AccessibilityContainer = styled.div.attrs(() => ({
  'data-test': 'accessibility-options-container'
}))`
  font-size: 14px;

  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  overflow: hidden;

  margin-top: 10px;
  padding-top: 1px;
  height: ${(props: AccessibilityContainerProps) => (props.visible ? 'fit-content' : '0px')};
  opacity: ${(props: AccessibilityContainerProps) => (props.visible ? '1' : '0')};

  transition: all 0.1s ease-out;
`;

type AccessibilityOptionContainerProps = {
  theme: any;
  visible?: boolean;
  enabled: boolean;
  fullWidth?: boolean;
  position?: string;
  'data-test'?: string;
};
export const AccessibilityOptionContainer = styled.button.attrs(
  (props: AccessibilityOptionContainerProps) => ({
    'data-test': props['data-test']
  })
)`
  display: ${props => (props.visible ? 'block' : 'none')};
  height: 85px;
  width: ${(props: AccessibilityOptionContainerProps) => (props.fullWidth ? '252px' : '117px')};

  border: none;
  border-radius: 8px;

  color: ${props =>
    props.enabled ? props.theme.colors.contentBodyColor : props.theme?.colors?.textColor};
  background-color: ${props =>
    props.enabled
      ? transparentize(props.theme?.colors?.ctaButtonColor, 1)
      : transparentize(props.theme?.colors?.textColor, 0.04)};

  margin-bottom: 1rem;
  padding: ${(props: AccessibilityOptionContainerProps) =>
    props.fullWidth ? '15px 35px 16px;' : '20px 9px 16px'};

  &:hover {
    ${props =>
      !props.enabled &&
      `background-color: ${transparentize(props.theme?.colors?.textColor, 0.09)};`}
    cursor: pointer;
  }
`;

type AccessibilityOptionProps = {
  'data-test'?: string;
};

export const AccessibilityOption = styled.div.attrs((props: AccessibilityOptionProps) => ({
  'data-test': props['data-test']
}))``;

type AccessibilityOptionTextProps = {
  theme: any;
  display?: string;
};

export const AccessibilityOptionText = styled.div.attrs(() => ({
  'data-test': 'accessibility-option-text'
}))<AccessibilityOptionTextProps>`
  font-family: ${props => props.theme.fonts.mainFont.fontFamily};
  display: block;
  padding: 13px 0 0 0;
`;

export const FontSizeAdjustmentOptionText = styled.div.attrs(() => ({
  'data-test': 'accessibility-option-text'
}))<AccessibilityOptionTextProps>`
  font-family: ${props => props.theme.fonts.mainFont.fontFamily};
  display: inline;
  padding: 0 0 0 10px;
`;

export const FontSizeAdjustmentContainer = styled.div.attrs(() => ({}))`
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-height: 25px;
  margin: 5px;
  border-radius: 10px;

  font-family: ${props => props.theme.fonts.mainFont.fontFamily};
  background-color: ${props => transparentize(props.theme?.colors?.textColor, 0.09)};
`;

export const FontSizeAdjustmentButton = styled.button`
  height: 30px;
  width: 30px;
  display: inline-block;

  border: none;
  border-radius: 100%;

  font-size: 20px;
  color: ${props => props.theme.colors.contentBodyColor};
  background-color: ${props =>
    transparentize(props.theme.colors.textColor, 0.6, { solidColor: true })};

  &:hover {
    background-color: ${props => props.theme.colors.textColor};
    cursor: pointer;
  }
`;
